module.exports = __webpack_public_path__ + "img/Responsible Citizen.dc79be53.svg";